import add from './add';
export default add;